<template>
  <div class="browe-trend">
    <div ref="myChart" :style="{ width: '100%', height: '430px' }"></div>
    <h1>
      <span>总数:{{ webDataBrowseTrend.total_pv }}</span>
      <span v-if="device == 2"
        >前一年总数:{{ webDataBrowseTrend.history_total_pv_count }}</span
      >
    </h1>
    <div class="device-choose">
      <p :class="device == 2 ? 'choosed' : ''" @click="choosedevice(2)">
        total
      </p>
      <p :class="device == 1 ? 'choosed' : ''" @click="choosedevice(1)">pc</p>
      <p :class="device == 0 ? 'choosed' : ''" @click="choosedevice(0)">
        mobile
      </p>
    </div>
  </div>
</template>
<script>
export default {
  props: { webDataBrowseTrend: Object, dates: Object },
  components: {},
  data() {
    return {
      xAxis: [],
      viewData: [],
      historyData: [],
      device: 2,
    };
  },
  watch: {
    immediate: true,
    webDataBrowseTrend(val, newval) {
      console.log(val);
      console.log(this.dates[0]);
      let oneDay = 1000 * 60 * 60 * 24;
      let arr = [];
      let days =
        (new Date(this.dates.end_time).getTime() -
          new Date(this.dates.start_time).getTime()) /
        oneDay;
      for (let i = 0; i < days; i++) {
        arr.push(
          this.$dtime(
            new Date(this.dates.start_time).getTime() + oneDay * i
          ).format("YYYY-MM-DD")
        );
      }

      this.xAxis = arr;
      console.log(new Date(this.dates.start_time).getTime());
      this.dataProcessing();
    },
  },
  methods: {
    choosedevice(val) {
      this.device = val;
      this.dataProcessing();
      // this.drawLine();
    },
    dataProcessing() {
      this.viewData = [];
      this.historyData = [];

      if (this.device == 2) {
        for (let i = 0; i < this.xAxis.length; i++) {
          if (this.webDataBrowseTrend.total_view_data[this.xAxis[i]]) {
            this.viewData.push(
              this.webDataBrowseTrend.total_view_data[this.xAxis[i]]
            );
          } else {
            this.viewData.push(0);
          }
        }
      }
      if (this.device == 1) {
        for (let i = 0; i < this.xAxis.length; i++) {
          if (this.webDataBrowseTrend.pc_view_data[this.xAxis[i]]) {
            this.viewData.push(
              this.webDataBrowseTrend.pc_view_data[this.xAxis[i]]
            );
          } else {
            this.viewData.push(0);
          }
        }
      }
      if (this.device == 0) {
        for (let i = 0; i < this.xAxis.length; i++) {
          if (this.webDataBrowseTrend.mobile_view_data[this.xAxis[i]]) {
            this.viewData.push(
              this.webDataBrowseTrend.mobile_view_data[this.xAxis[i]]
            );
          } else {
            this.viewData.push(0);
          }
        }
      }

      for (let i = 0; i < this.xAxis.length; i++) {
        let arr = this.xAxis[i].split("-");
        arr[0] = Number(arr[0]) - 1;
        let year = arr.join("-");
        if (this.webDataBrowseTrend.history_view_data[year]) {
          this.historyData.push(
            this.webDataBrowseTrend.history_view_data[year]
          );
        } else {
          this.historyData.push(0);
        }
      }
      this.drawLine();
      console.log(this.viewData);
      console.log(this.historyData);
    },
    drawLine() {
      let myChart = this.$echarts.init(this.$refs.myChart);
      console.log(myChart);
      myChart.setOption({
        color: ["#CAE6FF", "#FFEDC3"],
        title: {
          text: "浏览趋势",
        },
        tooltip: {
          backgroundColor: "rgba(50,50,50,0.9)",
          trigger: "axis",
          // formatter: "{b}: {c}\n ({d}%)",
          borderColor: "transparent",
          borderWidth: "5",
          textStyle: {
            fontSize: "12",
            lineHeight: "12",
            height: "10",
            color: "white",
          },
        },
        legend: {
          data: ["访问量", `${this.device == 2 ? "前一年访问量" : null}`],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.xAxis,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "访问量",
            // data: ["820", "932", "901", "934", "1290", "1330", "1320"],
            data: this.viewData,
            type: "line",
            smooth: true,
            // symbol: 'none',
            itemStyle: {
              color: "#4867BC",
            },
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#CAE6FF",
                },
                {
                  offset: 1,
                  color: "#fff",
                },
              ]),
            },
          },
          {
            name: "前一年访问量",
            // data: [320, 532, 401, 234, 860, 1030, 1880, 2199],
            data: this.device == 2 ? this.historyData : null,
            type: "line",
            smooth: true,
            // symbol: 'none',
            itemStyle: {
              color: "#F9BF56",
            },
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#FFEDC3",
                },
                {
                  offset: 1,
                  color: "#fff",
                },
              ]),
            },
          },
        ],
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.browe-trend {
  position: relative;
  h1 {
    position: absolute;
    top: -10px;
    right: 320px;
    color: $mainTitle;
    font-size: 20px;
    align-self: center;
    word-break: keep-all;
    display: inline-block;
    vertical-align: top;
    span {
      top: 55px;
      position: absolute;
      font-size: 12px;
      left: 27px;
    }
    span:nth-of-type(2) {
      position: absolute;
      font-size: 12px;
      left: 120px;
    }
  }
  .device-choose {
    position: absolute;
    top: 40px;
    left: 150px;
    display: flex;
    p {
      cursor: pointer;
      font-size: 12px;
      line-height: 20px;
      padding: 0px 10px;
      margin-right: 10px;
      border: 1px solid $timeBtn;
      border-radius: 10px;
    }
    p:hover {
      background: $timeBtn;
      color: $base-color;
    }
    .choosed {
      background: $timeBtn;
      color: $base-color;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/index/BrowseTrend.vue